import React, { memo } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import nl from 'date-fns/locale/nl';
import CloseIcon from '../svg/CloseIcon';
import FilterIcon from '../svg/FilterIcon';
import WisFilterIcon from '../svg/WisFilterIcon';
import Tag from '../AgendaContent/Tag';

registerLocale('nl', nl);

import { today, getTomorrow, getThisWeekend } from '../../utils/helpers';

const AgendaFilterbar = ({
	memoizedFilteredCount,
	memoizedActiveFilterDate,
	memoizedActiveTimestamp,
	memoizedDateRange,
	memoizedActiveLocations,
	memoizedActiveCategories,
	memoizedActiveAudiences,
	memoizedActiveTags,
	memoizedIsFree,
	memoizedIsDiscount,
	availableDates,

	showModal,
	toggleModal,
	handleParamClick,
	getParamLabels,
	getActiveLabels,
	handleFreeClick,
	handleDiscountClick,
	removeLabel,
	handleTagClass,
	setDateParam,
	setDateRangeParam,
	resetParams,
	config,
	displayAmountActiveFilters
}) => {

	const isActivePreset = (preset) => {
		if (memoizedActiveFilterDate) {
			if (memoizedActiveTimestamp === today) {
				if (memoizedDateRange) {
					if (`this ${memoizedDateRange}` === preset) return true;
				} else {
					if (preset === 'today') return true;
				}
			}
			if (memoizedActiveTimestamp === getTomorrow(today) && !memoizedDateRange) {
				if (preset === 'tomorrow') return true;
			}
			if (memoizedActiveTimestamp === getThisWeekend(today)) {
				if (preset === 'this weekend' && memoizedDateRange === 'weekend') return true;
			}
		}
	}

	const handlePresetDateClick = (preset) => {
		if (preset === 'today') {
			setDateParam(today);
			setDateRangeParam(null);
		} else if (preset === 'tomorrow') {
			setDateParam(getTomorrow(today));
			setDateRangeParam(null);
		} else if (preset === 'this week') {
			setDateParam(today);
			setDateRangeParam('week');
		} else if (preset === 'this month') {
			setDateParam(today);
			setDateRangeParam('month');
		} else if (preset === 'this weekend') {
			setDateParam(getThisWeekend(today));
			setDateRangeParam('weekend');
		}
	}

	const handleDatepickerClick = (date) => {
		setDateParam(date.getTime());
		setDateRangeParam(null);
	}

	return (
		<div className="">
			<div className='agenda-filter-bar'>
				<button onClick={toggleModal} className="agenda-filter-bar__button --no-fill">
					<h5 className="agenda-filter-bar__text">{customData.i18n.agenda_filter_button_mobile}</h5><FilterIcon/>
				</button>
				{ displayAmountActiveFilters() > 0 &&
					<>
						<div className="agenda-filter-bar__display-tags-container">
							<p className="agenda-filter-bar__Geselecteerd">{customData.i18n.agenda_filter_selected}</p>
							<button className="agenda-filter-bar__wis-filter" onClick={() => resetParams()} key={99}>{customData.i18n.agenda_delete_filters} <WisFilterIcon /> </button>

							<div className="agenda-filter-bar__tags-container">
								{
									getActiveLabels().map((label, index) => {
										return (
											<Tag key={index} onclick={() => removeLabel(label.value, label.group)} index={index} tagText={label.name} displayIcon={true}/>
										);
									})
								}
							</div>
						</div>
					</>
				}

			</div>
			{
				showModal &&
					<div className= "agenda-filters grid">
						<div className="grid-item clr-neutral--100">
							<div className="agenda-filters__head">
								<h2 className="agenda-filters__title">Agenda</h2>
								<button type="button" aria-label="Close" className="btn btn--full-width" onClick={toggleModal}><span className="btn--full-width__text">Sluiten</span> <CloseIcon/></button>
							</div>
							<div>
								<div className="agenda-filters__container" >

									<div className="agenda-filter-box agenda-filter-box--datepicker">
										<p className="agenda-filter-box__title">{customData.i18n.agenda_date_name}</p>

										<div className="agenda-filter-box__tags-container">
											{config.date_filter_range && config.date_presets &&
												config.date_presets.map((preset, index) =>
													<button type="button" aria-label="category choice"
														key={index}
														onClick={() => handlePresetDateClick(Object.keys(preset)[0])}
														className={isActivePreset(Object.keys(preset)[0]) ? 'tag--active tag' : 'tag'}
													><p className="tag__text">{Object.values(preset)[0]}</p></button>
												)
											}
										</div>

										<DatePicker
											selected={memoizedActiveTimestamp}
											onChange={(date) => handleDatepickerClick(date)}
											dateFormat="dd/MM/yyy"
											locale="nl"
											weekStartsOn={2}
											includeDates={availableDates.map((date, index) => {
												if (date >= today) {
													return date;
												}
											})}
											inline
										/>
									</div>

									{['location', 'audience', 'category', 'tag'].map((group, index) => {
										   let params = getParamLabels(group);
										if (group === 'audience') {
										const order = ['baby', 'peuter', 'kleuter','schoolkind', 'jongere', 'tiener', 'volwassene'];
											params = params.sort((a, b) => {
												const aId = Object.keys(a.value)[0];
												const bId = Object.keys(b.value)[0];
												return order.indexOf(aId) - order.indexOf(bId);
											});
										}

										return (
											<div className="agenda-filter-box" key={index}>
												<p className="agenda-filter-box__title">{customData.i18n[`agenda_${group}_name`]}</p>
												<div className="agenda-filter-box__tags-container">
													{params.map((param, paramIndex) => {
														return (
															<button
																key={paramIndex}
																onClick={() => handleParamClick(param.value, group, param.disabled, param.active)}
																className={handleTagClass(param)}
															><p className="tag__text">{param.name}</p></button>
														);
													})}
												</div>
											</div>
										);
									})}
								</div>

								{/* Discount and Free toggles; TODO: add functionality */}
								<div className="agenda-filters__checkbox-container">
									<label className="checkbox">
										<input type="checkbox" checked={memoizedIsDiscount} onChange={(e) => handleDiscountClick(e)}></input>
										<div className="checkbox__checkmark"></div>
											<p>{customData.i18n.agenda_discount_name}</p>
									</label>
									<label className="checkbox">
										<input type="checkbox" checked={memoizedIsFree} onChange={(e) => handleFreeClick(e)}></input>
										<div className="checkbox__checkmark"></div>
											<p>{customData.i18n.agenda_free_name}</p>
									</label>
								</div>

								<div className="agenda-filters__button-container">
									<button type="button" aria-label="show results" onClick={toggleModal} className="btn btn--full-width" href="#"><span className="btn--full-width__text">{memoizedFilteredCount} {memoizedFilteredCount.length === 1 ? customData.i18n.agenda_results_single : customData.i18n.agenda_results}</span></button>
								</div>
							</div>
						</div>
					</div>
			}
		</div>
	);
};

export default memo(AgendaFilterbar);
